import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconGoogle$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconGoogle extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '8962672c935b90dfe4c76db174252fee6ff4f32c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '5f06c46b9ac1b8274fb2d7eddbac56daa99412aa', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'c8adbd035a0e285a5a6b1113da89d91969f9a522', d: "M2 11c0-4.963 4.037-9 9-9 2.004 0 3.901.645 5.486 1.865l-2.091 2.717A5.5 5.5 0 0 0 11 5.429 5.58 5.58 0 0 0 5.429 11 5.577 5.577 0 0 0 11 16.571a5.58 5.58 0 0 0 5.302-3.857H11V9.286h9V11c0 4.963-4.037 9-9 9s-9-4.037-9-9", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-google", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-google"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-google":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconGoogle$1);
            }
            break;
    } });
}

const CosmosIconGoogle = CosmosIconGoogle$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconGoogle, defineCustomElement };
